// extracted by mini-css-extract-plugin
export default {"container":"Verse_container__xPuAf","title":"Verse_title__EhJLu","divider":"Verse_divider__YnCO1","verse":"Verse_verse__T9nrt"};